import React from "react";
import { Box } from "@mui/material";

import { Table, TableBody, TableCell, TableRow } from "ui";

import { TRANSFORMER_SIZE_OPTIONS } from "fond/project/panels/MuPower/architecture/constants";
import { PowerArchitecture, SystemOfMeasurement } from "fond/types";
import { convertMetersToFeet, formatUnit } from "fond/utils";
import { formatNumber } from "fond/utils/number";

interface MuPowerArchitectureSummaryProps {
  systemOfMeasurement: SystemOfMeasurement;
  powerArchitecture: PowerArchitecture | null;
}

const MuPowerArchitectureSummary: React.FC<MuPowerArchitectureSummaryProps> = ({ powerArchitecture, systemOfMeasurement }) => {
  if (!powerArchitecture) return null;

  const transformerSizes = TRANSFORMER_SIZE_OPTIONS.filter(({ Size }) => !!powerArchitecture.Transformers.Options[Size]).map(({ RatingKva }) =>
    formatNumber(RatingKva)
  );

  const transformerDescription = transformerSizes.length > 0 ? `${transformerSizes.join(", ")} kVA` : "None";
  const maxLengthMetres = powerArchitecture.SecondaryWires.MaxLengthMetres;
  const maxLengthDisplay = systemOfMeasurement === "imperial" ? convertMetersToFeet(maxLengthMetres) : maxLengthMetres;
  const secondaryDescription = formatNumber(maxLengthDisplay);

  return (
    <Box mb={1}>
      <Table size="small" variant="ag-grid-compact">
        <TableBody>
          <TableRow>
            <TableCell>Average meter load</TableCell>
            <TableCell align="right">
              <b>{formatNumber(powerArchitecture.Transformers.AverageMeterLoadAmps)} A</b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Max circuit load</TableCell>
            <TableCell align="right">
              <b>{formatNumber(powerArchitecture.PrimaryWires.MaxSourceLoadAmps)} A</b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Transformer sizes</TableCell>
            <TableCell align="right">
              <b>{transformerDescription}</b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Max secondary wire length</TableCell>
            <TableCell align="right">
              <b>
                {secondaryDescription} {formatUnit(systemOfMeasurement)}
              </b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default MuPowerArchitectureSummary;
